import { getChainDisplayName } from '@passkeys/assets';
import { useCopyToClipboard } from '@passkeys/hooks';
import ChainIcon from '@passkeys/ui/chain-icon';
import Text from '@passkeys/ui/text';

import exodus from '@/ui/exodus.js';
import useAsset from '@/ui/hooks/use-asset';
import CopyableAddress from './copyable-address.js';
import { CHAIN_ITEM_HEIGHT } from '../constants.js';

function ChainItem({ name, address }) {
  const { copy, copied } = useCopyToClipboard();

  const handleClick = () => {
    copy(address);

    exodus.analytics.track({
      event: 'WalletAddressDropdownCopy',
      properties: {
        network: name,
      },
    });
  };

  const asset = useAsset(name);
  if (!asset) {
    throw new Error(`${name} is not supported`);
  }

  const displayName = getChainDisplayName(asset);

  return (
    <button
      className="ml-[-4px] flex w-[calc(100%+8px)] items-center gap-x-2 rounded-[9px] p-1 transition-colors enabled:hover:bg-black/4 theme-dark:enabled:hover:bg-white/4"
      onClick={handleClick}
      type="button"
      style={{ height: `${CHAIN_ITEM_HEIGHT}px` }}
      disabled={copied}
    >
      <div className="flex flex-1 shrink-0 items-center gap-x-2">
        <ChainIcon name={name} displayName={displayName} noShadow />
        <Text
          size={12}
          className="whitespace-nowrap text-gray-500 theme-dark:text-neutral-200"
        >
          {displayName}
        </Text>
      </div>
      <CopyableAddress address={address} copied={copied} />
    </button>
  );
}

export default ChainItem;
